import { useIntl } from 'react-intl';
import { Button } from 'src/components';
import { useHref } from 'src/hooks/useHref';
import { ROUTES } from 'src/constants/routes.const';
import { Header } from '../Header';
import { msgs } from './messages';
import * as S from './styles';
import ErrorImageSvg from './images/error.svg';

export const NotFoundErrorPage = () => {
  const intl = useIntl();

  const courseHref = useHref({ pathname: ROUTES.course });

  return (
    <>
      <Header />

      <S.ContentContainer>
        <S.ErrorImage Svg={ErrorImageSvg} />
        <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
        <S.Subtitle>{intl.formatMessage(msgs.subtitle)}</S.Subtitle>
        <Button
          analyticsEvent="none"
          buttonSize="large"
          buttonType="primary"
          disableMinWidth
          fullWidth="never"
          href={courseHref}
        >
          {intl.formatMessage(msgs.cta)}
        </Button>
      </S.ContentContainer>
    </>
  );
};
